import React from 'react';
import { Link } from 'react-router-dom';
var SnakesPage = function () {
    return (React.createElement("div", { style: {
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            padding: '20px',
            boxSizing: 'border-box'
        } },
        React.createElement("div", null,
            React.createElement(Link, { to: "/", style: { textDecoration: 'none', color: '#2196F3' } }, "\u2190 Back to Home"),
            React.createElement("h1", null, "Snakes")),
        React.createElement("iframe", { src: "/games/snakes/index.html", style: {
                width: '100%',
                flex: 1,
                border: 'none'
            }, title: "Snakes Game" })));
};
export default SnakesPage;
